import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Route, Routes } from 'react-router-dom';
import Home from './Components/Home/Home/Home';
import Footer from './Components/Shared/Footer';
import AboutMe from './Components/AboutMe';





function App() {
  return (
    <div>
      <Routes>
        <Route path='/' element={<Home></Home>}></Route>
        <Route path='/home' element={<Home></Home>}></Route>
        <Route path='/aboutme' element={<AboutMe></AboutMe>}></Route>
      </Routes>
      <Footer></Footer>



    </div>
  );
}

export default App;
